import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function listPayStubEmployees(includeInactive, token) {
  const res = await axios.get(`${API}/hr/paystubs/employees`, {
    params: includeInactive ? { include_inactive: true } : {},
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getPayStubDetail(staffId, token) {
  const res = await axios.get(`${API}/hr/paystubs/${staffId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updatePayStubDetail(staffId, payload, token) {
  const res = await axios.put(`${API}/hr/paystubs/${staffId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
